import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _mergeProps({
        class: _ctx.getClasses.wrap,
        style: _ctx.getStyles
    }, _ctx.$attrs, {
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.listener && _ctx.listener(...args)))
    }), [
        _renderSlot(_ctx.$slots, "icon", {}, undefined, true),
        (_ctx.title)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(_ctx.getClasses.title)
            }, _toDisplayString(_ctx.title), 3))
            : _createCommentVNode("", true),
        (_ctx.content)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.getIsString)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.getClasses.description)
                    }, _toDisplayString(_ctx.content), 3))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.content, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: _normalizeClass(_ctx.getClasses.description)
                        }, _toDisplayString(item), 3));
                    }), 128))
            ], 64))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 16));
}
